import { Controller } from "@hotwired/stimulus"

// Shows a turbo-frame while a checkbox is ticked, loading it on the first tick.
export default class extends Controller {
  static targets = ["frame"]
  static values = { url: String }

  toggle(event) {
    const checked = event.currentTarget.checked
    this.frameTarget.hidden = !checked
    if (checked && !this.frameTarget.getAttribute("src")) {
      this.frameTarget.setAttribute("src", this.urlValue)
    }
  }
}
